import React from 'react';
import './App.css';
import AppRouter from './router/AppRouter';
import { AuthProvider } from './context/AuthContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { DurationFilterProvider } from './context/DurationFilterContext';

const GOOGLE_CLIENT_ID = "80712010535-4ijui2da9pmbg6hoi6tf5873g924p3sq.apps.googleusercontent.com";

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_CLIENT_ID}>
      <AuthProvider>
        <DurationFilterProvider>
          <AppRouter />
        </DurationFilterProvider>
      </AuthProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
